import styled from "styled-components/macro"
import theme from "theme"

export const StyledTooltip = styled.div`
  background: rgba(70, 70, 70, 0.9);
  border-radius: 2px;
  box-shadow: 0 1px 3px 0 ${theme.color.shadow};
  padding: 10px;
`
